import React, { useRef } from "react";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import yogaGirl from "../../assets/images/footer/svg/yoga-girl.svg";
import Button from "./button/Button";
import { Link, useLocation } from "react-router-dom";
const SahajYogaCard = ({click}) => {
  let location = useLocation();


  return (
    <>
      <div
        className={`${
          location.pathname === "/" ? "mt-5" : ""
        } position-relative z-1 pt-5`}
      >
        {/*<img
          className="position-absolute end-0 footer_bottom_flower_img"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/}
        <div className="container container_modified position-relative">
          <div className="footer_card_bg text-center text-lg-start">
            <h3 className="font-xl fw-semibold text-white mb-0">Sahaj Yoga</h3>
            <p className="font-sm fw-medium text-white py-3 mb-0">
              Transform Your Life With This Powerful Mahamantra 
              <br className="d-none d-sm-block" />
              Hari Om Tatsat Jay Guru Datt
            </p>
            <Link to="/hari-om-tatsat-jai-guru-datta" onClick={()=>click()} >
              <Button title="Learn More" />
            </Link>
            <div>
              <img
                className="footer_card_yoga_girl"
                src={yogaGirl}
                alt="yoga-girl"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SahajYogaCard;
